module.exports = __webpack_public_path__ + "img/H5_guide.9d3f3013.jpg";